module.exports = __webpack_public_path__ + "img/team_map.71764d4b.png";